import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styleable from 'react-styleable';
import AssignCourseFilter from './pages/assign-course-filter';
import SelectCourse from './pages/select-course';
import css from './index.scss';
import Button from '../button/index';
import messages from './messages';

const AssignCourseUPF = props => (
    <div className={css.assignCourse}>
        <AssignCourseFilter {...props} />
        <SelectCourse {...props} />
        <div className={css.footer}>
            <Button
                containerClassName={css.assignToYear}
                disabled={props.disableAssignToYear}
                handleOnClick={() => props.assignToYearGroup('upf')}
                label={props.forYear ? props.intl.formatMessage(messages.assignToYear) : props.intl.formatMessage(messages.assignToGroup)}
            />
        </div>
    </div>
);

AssignCourseUPF.propTypes = {
    intl: intlShape.isRequired,
    assignToYearGroup: PropTypes.func.isRequired,
    disableAssignToYear: PropTypes.bool.isRequired,
    forLegacy: PropTypes.bool,
    forYear: PropTypes.bool,
    handleOptOutOfCourse: PropTypes.func,
    isUPFSelected: PropTypes.bool
};

export default injectIntl(styleable(css)(AssignCourseUPF));



// WEBPACK FOOTER //
// ./app/components/assign-course-upf/index.js